const MessageList = () => import('@pages/user/MessageList')
const DoctorSubscribes = () => import('@pages/user/DoctorSubscribe')
const FilmList = () => import('@pages/user/FilmList')
const AppointmentList = () => import('@pages/user/AppointmentList')
const AppointmentShow = () => import('@pages/user/AppointmentShow')
const AppointmentPayment = () => import('@pages/user/AppointmentPayment')
const AppointmentOrder = () => import('@pages/user/AppointmentOrder')
const EMAppointmentList = () => import('@pages/user/EMAppointmentList')
const EMAppointmentShow = () => import('@pages/user/EMAppointmentShow')
const Guide = () => import('@pages/user/Guide')
const SelectChannel = () => import('@pages/user/SelectChannel')
const Statement = () => import('@pages/mes/Statement')
const Covid19Diagnosis = () => import('@pages/user/Covid19Diagnosis')
const BloodAppointment = () => import('@pages/blood/Appointment')
const BloodPayment = () => import('@pages/blood/Payment')
const CabinSupplement = () => import('@pages/cabin/Supplement')
const CabinSupplementSuccess = () => import('@pages/cabin/SupplementSuccess')
const CabinDailyInspection = () => import('@pages/cabin/DailyInspection')
const CabinDailyInspectionSuccess = () => import('@pages/cabin/DailyInspectionSuccess')
const CabinVolunteerSignUp = () => import('@pages/cabin/VolunteerSignUp')
const CabinVolunteerDaily = () => import('@pages/cabin/VolunteerDaily')
const CabinRegBed = () => import('@pages/cabin/RegBed')
const CabinRegBedLhasa = () => import('@pages/cabin/RegBedLhasa')
const CabinRegistration = () => import('@pages/cabin/Registration')
const CabinRegSuccess = () => import('@pages/cabin/RegSuccess')
const CovidGuide = () => import('@pages/user/CovidGuide')
const OrderRemind = () => import('@pages/mes/OrderRemind')
const ViewShow = () => import('@pages/user/ViewShow')
const PatientFilm = () => import('@pages/user/PatientFilm')
const InspectFilm = () => import('@pages/user/InspectFilm')
const FFReg = () => import('@pages/ffClinc/FFReg')
const FFPatient = () => import('@pages/ffClinc/FFPatient')
const FFTRecord = () => import('@pages/ffClinc/TRecord')
const FFUseRecord = () => import('@pages/ffClinc/UseRecord')
const FFResultRecord = () => import('@pages/ffClinc/ResultRecord')
const FFDiseaseRecord = () => import('@pages/ffClinc/DiseaseRecord')
const FFAllTRecord = () => import('@pages/ffClinc/AllTRecord')
const FFAllUseRecord = () => import('@pages/ffClinc/AllUseRecord')
const FFAllResultRecord = () => import('@pages/ffClinc/AllResultRecord')
const FFAllDiseaseRecord = () => import('@pages/ffClinc/AllDiseaseRecord')
const FFPatientShow = () => import('@pages/ffClinc/FFPatientShow')
const CreateFFPatient = () => import('@pages/ffClinc/CreateFFPatient')
const FFTShow = () => import('@pages/ffClinc/TShow')
const FFUseShow = () => import('@pages/ffClinc/UseShow')
const FFResultShow = () => import('@pages/ffClinc/ResultShow')
const FFDiseaseShow = () => import('@pages/ffClinc/DiseaseShow')
const FFMain = () => import('@pages/ffClinc/FFMain')
export const user = [
  {
    path: '/messages/list',
    name: 'MessageList',
    component: MessageList,
    meta: {}
  }, {
    path: '/doctor/subscribes',
    name: 'DoctorSubscribes',
    component: DoctorSubscribes,
    meta: {}
  }, {
    path: '/user/film_list',
    name: 'FilmList',
    component: FilmList,
    meta: {}
  }, {
    path: '/appointments/list',
    name: 'AppointmentList',
    component: AppointmentList,
    meta: {}
  }, {
    path: '/appointments/show/:id',
    name: 'AppointmentShow',
    component: AppointmentShow,
    meta: {}
  }, {
    path: '/appointments/payment',
    name: 'AppointmentPayment',
    component: AppointmentPayment,
    meta: {}
  }, {
    path: '/appointments/order/:apId',
    name: 'AppointmentOrder',
    component: AppointmentOrder,
    meta: {}
  }, {
    path: '/em_appointments/list',
    name: 'EMAppointmentList',
    component: EMAppointmentList,
    meta: {}
  }, {
    path: '/em_appointments/show/:id',
    name: 'EMAppointmentShow',
    component: EMAppointmentShow,
    meta: {}
  }, {
    path: '/user/guide',
    name: 'Guide',
    component: Guide,
    meta: {title: '用户绑卡'}
  }, {
    path: '/user/select_channel',
    name: 'SelectChannel',
    component: SelectChannel,
    meta: {}
  }, {
    path: '/user/statement',
    name: 'Statement',
    component: Statement,
    meta: {title: '体检须知'}
  }, {
    path: '/user/covid19_diagnosis',
    name: 'Covid19Diagnosis',
    component: Covid19Diagnosis,
    meta: {}
  }, {
    path: '/reg/pay/bloodAppointment',
    name: 'BloodAppointment',
    component: BloodAppointment,
    meta: {}
  }, {
    path: '/reg/pay/bloodPayment',
    name: 'BloodPayment',
    component: BloodPayment,
    meta: {}
  }, {
    path: '/reg/cabin/Supplement',
    name: 'CabinSupplement',
    component: CabinSupplement,
    meta: {auth: false}
  }, {
    path: '/reg/cabin/SupplementSuccess',
    name: 'CabinSupplementSuccess',
    component: CabinSupplementSuccess,
    meta: {auth: false}
  }, {
    path: '/reg/cabin/DailyInspection',
    name: 'CabinDailyInspection',
    component: CabinDailyInspection,
    meta: {}
  }, {
    path: '/reg/cabin/VolunteerSignUp',
    name: 'CabinVolunteerSignUp',
    component: CabinVolunteerSignUp,
    meta: {}
  }, {
    path: '/reg/cabin/VolunteerDaily',
    name: 'CabinVolunteerDaily',
    component: CabinVolunteerDaily,
    meta: {}
  }, {
    path: '/reg/cabin/DailyInspectionSuccess',
    name: 'CabinDailyInspectionSuccess',
    component: CabinDailyInspectionSuccess,
    meta: {}
  }, {
    path: '/reg/cabin/RegBed',
    name: 'CabinRegBed',
    component: CabinRegBed,
    meta: {auth: false}
  }, {
    path: '/reg/cabin/RegBedLhasa',
    name: 'CabinRegBedLhasa',
    component: CabinRegBedLhasa,
    meta: {auth: false}
  }, {
    path: '/reg/cabin/Registration',
    name: 'CabinRegistration',
    component: CabinRegistration,
    meta: {auth: false}
  }, {
    path: '/reg/cabin/RegSuccess',
    name: 'CabinRegSuccess',
    component: CabinRegSuccess,
    meta: {auth: false}
  }, {
    path: '/user/covid_guide',
    name: 'CovidGuide',
    component: CovidGuide,
    meta: {}
  }, {
    path: '/user/order_remind',
    name: 'OrderRemind',
    component: OrderRemind,
    meta: {}
  }, {
    path: '/user/view_show',
    name: 'ViewShow',
    component: ViewShow,
    meta: {}
  }, {
    path: '/user/patient_film',
    name: 'PatientFilm',
    component: PatientFilm,
    meta: {}
  }, {
    path: '/reg/inspect_film',
    name: 'InspectFilm',
    component: InspectFilm,
    meta: {auth: false}
  }, {
    path: '/reg/ffClinc/FFReg',
    name: 'FFReg',
    component: FFReg,
    meta: {auth: false}
  }, {
    path: '/reg/ffClinc/FFPatient',
    name: 'FFPatient',
    component: FFPatient,
    meta: {auth: false}
  }, {
    path: '/reg/ffClinc/AllTRecord',
    name: 'AllTRecord',
    component: FFAllTRecord,
    meta: {}
  }, {
    path: '/reg/ffClinc/AllUseRecord',
    name: 'AllUseRecord',
    component: FFAllUseRecord,
    meta: {}
  }, {
    path: '/reg/ffClinc/AllResultRecord',
    name: 'AllResultRecord',
    component: FFAllResultRecord,
    meta: {}
  }, {
    path: '/reg/ffClinc/AllDiseaseRecord',
    name: 'AllDiseaseRecord',
    component: FFAllDiseaseRecord,
    meta: {}
  }, {
    path: '/reg/ffClinc/FFPatientShow',
    name: 'FFPatientShow',
    component: FFPatientShow,
    meta: {}
  }, {
    path: '/reg/ffClinc/CreateFFPatient',
    name: 'CreateFFPatient',
    component: CreateFFPatient,
    meta: {}
  }, {
    path: '/reg/ffClinc/TShow',
    name: 'TShow',
    component: FFTShow,
    meta: {}
  }, {
    path: '/reg/ffClinc/UseShow',
    name: 'UseShow',
    component: FFUseShow,
    meta: {}
  }, {
    path: '/reg/ffClinc/ResultShow',
    name: 'ResultShow',
    component: FFResultShow,
    meta: {}
  }, {
    path: '/reg/ffClinc/DiseaseShow',
    name: 'DiseaseShow',
    component: FFDiseaseShow,
    meta: {}
  }, {
    path: '/reg/ffClinc/FFMain',
    name: 'FFMain',
    component: FFMain,
    meta: {},
    children: [
      {
        path: '/TRecord',
        name: 'TRecord',
        component: FFTRecord,
        meta: {}
      }, {
        path: '/UseRecord',
        name: 'UseRecord',
        component: FFUseRecord,
        meta: {}
      }, {
        path: '/ResultRecord',
        name: 'ResultRecord',
        component: FFResultRecord,
        meta: {}
      }, {
        path: '/DiseaseRecord',
        name: 'DiseaseRecord',
        component: FFDiseaseRecord,
        meta: {}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/user.route.js